import Vue from "vue";
import VueRouter, { NavigationGuardNext, Route, RouteConfig } from "vue-router";
import DelaiLocationPlugin from "../plugins/delai";
import store from "../store";

Vue.use(VueRouter);

type ModuleType = typeof import("*.vue");

const Clientele = (): Promise<ModuleType> =>
  import(/* webpackChunkName: "clientele" */ "../views/Clientele.vue");
const Periode = (): Promise<ModuleType> =>
  import(/* webpackChunkName: "periode" */ "../views/Periode.vue");
const Emplacement = (): Promise<ModuleType> =>
  import(/* webpackChunkName: "emplacement" */ "../views/Emplacement.vue");
const Casier = (): Promise<ModuleType> =>
  import(/* webpackChunkName: "casier" */ "../views/Casier.vue");
const Revision = (): Promise<ModuleType> =>
  import(/* webpackChunkName: "revision" */ "../views/Revision.vue");
const Paiement = (): Promise<ModuleType> =>
  import(/* webpackChunkName: "paiement" */ "../views/Paiement.vue");
const TrainProgression = (): Promise<ModuleType> =>
  import(/* webpackChunkName: "train" */ "../components/TrainProgression.vue");
const Connexion = (): Promise<ModuleType> =>
  import(/* webpackChunkName: "connexion" */ "../views/Connexion.vue");
const Accueil = (): Promise<ModuleType> =>
  import(/* webpackChunkName: "accueil" */ "../views/Accueil.vue");

const Test = (): Promise<ModuleType> =>
  import(/* webpackChunkName: "test" */ "../views/Test.vue");

const enFermetureComplete = process.env.VUE_APP_FERMETURE_COMPLETE === "true";
const enProduction = process.env.NODE_ENV === "production";

export const routes: RouteConfig[] = [
  {
    path: "/",
    name: "Accueil",
    component: Accueil,
    meta: {
      auth: true,
    },
  },
  {
    path: "/connexion",
    name: "Connexion",
    component: Connexion,
    meta: {
      auth: false,
    },
  },
  {
    path: "/location",
    component: TrainProgression,
    meta: {
      auth: true,
    },
    children: [
      { path: "", name: "Location", redirect: "clientele" },
      {
        path: "clientele",
        name: "Clientele",
        component: Clientele,
      },
      {
        path: "periode",
        name: "Periode",
        component: Periode,
      },
      {
        path: "emplacement",
        name: "Emplacement",
        component: Emplacement,
      },
      {
        path: "casier",
        name: "Casier",
        component: Casier,
      },
      {
        path: "revision",
        name: "Revision",
        component: Revision,
      },
      {
        path: "paiement",
        name: "Paiement",
        component: Paiement,
      },
    ],
  },
  {
    path: "/test",
    name: "Test",
    component: Test,
    meta: {
      auth: true,
    },
    beforeEnter: (
      _to: Route,
      _from: Route,
      next: NavigationGuardNext<Vue>
    ): void => {
      // Empêcher l'accès à la page de test en production
      if (enProduction) {
        return next({ name: "Accueil" });
      } else {
        next();
      }
    },
  },
  { path: "*", name: "NotFound", redirect: "/" },
];

const router: VueRouter = new VueRouter({
  routes,
});

router.beforeEach((to, _from, next): void => {
  if (enFermetureComplete) {
    // Empêcher l'accès aux autres pages dans le cas où le site est en fermeture complète
    for (const route of to.matched) {
      if (route.name !== "Accueil") {
        next({ name: "Accueil" });
      }
    }
  } else {
    for (const route of to.matched) {
      if (
        route.meta?.auth === true &&
        router.app.$msal.data.isAuthenticated === false
      ) {
        // Renvoyer à la connexion une page qui nécessite l'authentification
        return next({ name: "Connexion" });
      }

      if (
        route.meta?.auth === false &&
        router.app.$msal.data.isAuthenticated === true
      ) {
        // Renvoyer à l'accueil une page qui ne nécessite pas une authentification
        return next({ name: "Accueil" });
      }

      if (
        route.parent &&
        route.parent.path &&
        route.parent.path.indexOf("location") > -1
      ) {
        store.state.utilisateur.isDelaiLocationDepasse = DelaiLocationPlugin.isDelaiLocationDepasse();
      }
    }

    next();
  }
});

export default router;
